import * as BbsUsingG2 from './BbsUsingG2';

export { BbsUsingG2 };

export const suiteTypes = {
  BbsUsingG2: BbsUsingG2,
};
